import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../assets/icons"
import { UserReportReasonType, getUserReportReasonTypeToString } from "../../models/base/UserReportReasonType";
import { UserBasicInfoDTO } from "../../models/user/user.response";
import { useNotification } from "../toster-notification/NotificationContext";
import { useParams } from "react-router-dom";
import { userService } from "../../services/userService";
import Loader from "./Loader";
import { CreateUserReportDTO } from "../../models/userReport/userReport.request";
import { UserReportsService } from "../../services/userReportsService";
import { handleErrorNotification } from "../../utils/errorNotificatioMessage";


interface UserReportViewProps {
    reservationId?: string;
    orderId?: string;
    id: string;
    onClose: () => void
}

const UserReportView: React.FC<UserReportViewProps> = ({ id, onClose, reservationId, orderId }) => {

    const [userInfo, setUserInfo] = useState<UserBasicInfoDTO>();
    const [reportData, setReportData] = useState<CreateUserReportDTO>({
        description: "",
        reasonType: UserReportReasonType.Other,
        reportedUserId: id,
    });

    const [loading, setLoading] = useState<boolean>(false);
    const localId = useParams().localId;
    const { notify } = useNotification();


    useEffect(() => {
        fetchUserInfo();
    }, [id]);


    const fetchUserInfo = async () => {
        setLoading(true);
        try {
            const response = await userService.getBasicInfo(id);

            if (response.data && response.success) {
                setUserInfo(response.data);
            } else {
                notify("error", "Greška prilikom dobavljanja podataka");
            }
        } catch (error) {
            notify("error", "Greška prilikom dobavljanja podataka");
        } finally {
            setLoading(false);
        }
    };

    const handleReportSubmit = async () => {
        if (!localId) {
            notify("error", "Nije moguće poslati prijavu bez lokalnog ID-a");
            return;
        }

        if (!reportData.reasonType || !reportData.description) {
            notify("error", "Molimo popunite sve obavezne podatke");
            return;
        }

        setLoading(true);

        if (reservationId) {
            reportData.reservationId = reservationId;
        } else if (orderId) {
            reportData.orderId = orderId;
        }

        try {
            const response = await UserReportsService.createUserReport({ ...reportData, localId });

            if (response.success) {
                notify("success", "Prijava je uspješno poslana");
                onClose();
            } else {
                notify("error", "Greška prilikom slanja prijave");
            }
        } catch (error) {
            notify("error", "Greška prilikom slanja prijave");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />
    }

    return (
        <section className="modal-section user-report">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header fc-red">Prijavi korisnika</div>
                                <div className="description-text">
                                    Prijavite korisnika <span className="bold black">{userInfo?.fullName} </span>
                                    za zlonamernu aktivnost. Super admin će pregledati prijavu.
                                </div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" onClick={() => onClose()} />
                            </div>
                        </div>
                        <div className="modal-user-info-div">
                            <div className="modal-user-info-image-div">
                                <img src={userInfo?.imageUrl + "@lg.webp"} loading="lazy" alt="" className="modal-user-info-image" />
                            </div>
                            <div className="modal-user-info-data-div">
                                <div className="fs-1-125rem bold">{userInfo?.fullName}</div>
                                <div className="description-text">{userInfo?.phoneNumber}</div>
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form">
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Tip prijave*</label>
                                    <select className="form-select auto-width w-select"
                                        value={reportData.reasonType}
                                        onChange={(e) => setReportData({ ...reportData, reasonType: parseInt(e.target.value) as UserReportReasonType })}
                                    >
                                        <option value="">Izaberi razlog</option>

                                        {Object.values(UserReportReasonType)
                                            .filter((reason) => typeof reason === "number")
                                            .map((reason) => (
                                                <option key={reason} value={reason}>
                                                    {getUserReportReasonTypeToString(reason as UserReportReasonType)}
                                                </option>
                                            ))}

                                    </select>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Poruka / Obrazloženje *</label>
                                    <textarea placeholder="Opis incidenta..." className="form-textarea grey w-input"
                                        value={reportData.description}
                                        onChange={(e) => setReportData({ ...reportData, description: e.target.value })}
                                    />
                                    <div className="description-text fs-0-8rem">Budite što precizniji - navedite datume, iznose, detalje incidenta.</div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={() => onClose()}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium red-bg" onClick={() => handleReportSubmit()}>
                                <div>Pošalji prijavu</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default UserReportView;